import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes2';
import { Dimmer } from "../../spinner";
import moment from 'moment';
import {
    formatMoneda, validaMonto, formatoMonto,
    seleccionarCampo, round
} from '../../../util/varios';
import TablaDeudaContribuyentes from './tablaDeudaContribuyentes';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { AgregarPago } from './modalFormadePago';
import axios from 'axios';
import { ProcesosMontos } from './modalAgregarProcesoMontos';
import { useWebSocket } from '../../../context/WebSocketContext';

// Constantes fuera del componente para evitar recreaciones
const METODOS_PAGO = [
    { op: 2, icon: "fa-credit-card", text: "Tarjeta de Debito" },
    { op: 5, icon: "fab fa-cc-visa", text: "Tarjeta de Credito" },
    { op: 4, icon: "fa-money-check", text: "Deposito Bancario" },
    { op: 3, icon: "fa-laptop", text: "Transferencia Bancaria" },
    { op: 6, icon: "fa-mobile-alt", text: "Pago Movil" },
    { op: 8, icon: "fa-money-check-alt", text: "Saldo a Credito" },
    { op: 9, icon: "fa-pager", text: "Saldo en Anticipo" }
];


const TIPOS_PAGO = {
    2: "Tarjeta de Debito",
    5: "Tarjeta de Credito",
    4: "Deposito Bancario",
    3: "Transferencia Bancaria",
    6: "Pago Movil",
    8: "Saldo a Credito",
    9: "Saldo en Anticipo"
};

const DESCRIPCIONES_PAGO = {
    2: "TARJETA DE DEBITO",
    3: "TRANSFERENCIA",
    4: "DEPOSITO",
    5: "TARJETA DE CREDITO",
    6: "PAGO MOVIL",
    8: "Saldo a Credito $",
    9: "Saldo Anticipo $"
};

// Headers para la tabla
const HEAD_CELLS = [
    { id: 'tipopago', label: 'Tipo de Pago', align: 'center' },
    { id: 'documento', label: 'N° de Documento', align: 'center' },
    { id: 'banco', label: 'Nombre del Banco', align: 'center' },
    { id: 'monto', label: 'Monto', align: 'center' },
    { id: 'acciones', label: '-', align: 'center' }
];

export const RegistrarPago = (props) => {
    const { isConnected, sendPrint } = useWebSocket();
    const printer = JSON.parse(localStorage.getItem('impresora'));
    // =========================================================================
    // ESTADOS
    // =========================================================================
    const [impresora, setImpresora] = useState(null);
    const [totalcredito, setTotalcredito] = useState(0.0);
    const [anticipos, setAnticipos] = useState(0.0);
    const [records, setRecords] = useState([]);
    const [restabs, setRestabs] = useState(0.0);
    const [totaldeuda, setTotaldeuda] = useState(0.0);
    const [totaldeudabs, setTotaldeudabs] = useState(0.0);
    const [tasa, setTasa] = useState(1.00);
    const [totales, setTotales] = useState(0.0);
    const [sobrabs, setSobrabs] = useState(0.0);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habilitado, setHabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [formaPago, setFormaPago] = useState([]);
    const [montoPorPagar, setMontoPorPagar] = useState(0.00);
    const [montoPagado, setMontoPagado] = useState(0.00);
    const [tipoinput, setTipoinput] = useState(null);

    // =========================================================================
    // CONSTANTES
    // =========================================================================
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const numCaja = JSON.parse(localStorage.getItem('numcaja'));
    const token = localStorage.getItem('jwtToken');
    const op = require('../../../../src/modulos/datos');

    // =========================================================================
    // REFS
    // =========================================================================
    const txtCodigo = useRef();
    const txtNombreContri = useRef();
    const txtCedRif = useRef();
    const txtConcepto = useRef();
    const txtEfectivo = useRef();
    const txtFecha = useRef();
    const btnCancela = useRef();
    const btnAcepta = useRef();

    // =========================================================================
    // STYLES
    // =========================================================================
    const styleInput = {
        backgroundColor: '#ffff',
        color: '#444242'
    };

    // =========================================================================
    // VALORES MEMORIZADOS
    // =========================================================================
    const totalFactura = useMemo(() => {
        return parseFloat(props.factura?.totalfactura || 0);
    }, [props.factura]);

    const totalImpuestos = useMemo(() => {
        return (
            parseFloat(props.factura?.totalinmpuesto || 0) +
            parseFloat(props.factura?.totalinteres || 0) +
            parseFloat(props.factura?.totalmulta || 0) +
            parseFloat(props.factura?.totalrecargo || 0)
        );
    }, [props.factura]);

    // =========================================================================
    // FUNCIONES AUXILIARES
    // =========================================================================
    const obtenerDescripcionPago = useCallback((formapago) => {
        return DESCRIPCIONES_PAGO[formapago] || "";
    }, []);

    const recalcularTotales = useCallback((nuevosRecords, efectivo) => {
        // Calcular total cargado
        const nuevoTotal = nuevosRecords.reduce((acc, record) =>
            acc + parseFloat(record.monto || 0), 0
        );
        const totalRedondeado = round(nuevoTotal + efectivo);

        // Calcular restante
        const restante = round(totalImpuestos) - totalRedondeado;
        const nuevoRestante = restante < 0 ? 0 : restante;

        // Calcular sobrante
        let nuevoSobrante = 0;
        if (props.factura?.tabladeuda === 'abono') {
            nuevoSobrante = totalRedondeado;
        } else {
            nuevoSobrante = totalRedondeado > totalImpuestos
                ? totalRedondeado - totalImpuestos
                : 0;
        }

        return {
            total: totalRedondeado,
            restante: nuevoRestante,
            sobrante: nuevoSobrante
        };
    }, [totalImpuestos, props.factura?.tabladeuda]);

    const imprimirTicket = useCallback(async (numfactura) => {
        if (!impresora) return;

        try {
            const endpoint = `http://${impresora}:9000/imprimir?idfactura=${numfactura}&tipo=1`;
            await axios.get(endpoint);
        } catch (error) {
            console.error('Error al imprimir ticket:', error);
        }
    }, [impresora]);

    const handleCloseSi = useCallback(() => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }, []);

    // =========================================================================
    // EFFECTS
    // =========================================================================
    useEffect(() => {
        const impresoraStorage = localStorage.getItem('impresora');
        if (impresoraStorage) {
            try {
                setImpresora(JSON.parse(impresoraStorage));
            } catch (error) {
                console.error('Error parsing impresora:', error);
            }
        }
    }, []);

    useEffect(() => {
        const montoEfectivo = parseFloat(txtEfectivo.current?.value.replace(/\./g, '').replace(',', '.') || 0);
        const { total, restante, sobrante } = recalcularTotales(records, montoEfectivo);
        setTotales(total);
        setRestabs(restante);
        setSobrabs(sobrante);
    }, [records, recalcularTotales]);

    // =========================================================================
    // HANDLERS DE ENTRADA - CORREGIDOS
    // =========================================================================
    const handleInputMontoChange = useCallback((event) => {
        validaMonto(event);
        event.preventDefault()

        if (event.target.value === "" || parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) === 0) {
            event.target.value = "0,00";
        }

        if (event.which === 13 || typeof event.which === 'undefined') {
            event.target.value = formatoMonto(event.target.value);

            // Validar y formatear
            const char1 = event.target.value.substring(0, 1);
            const char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(1, event.target.value.length);
            }

            const valorNumerico = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.') || 0);

            if (event.target.id === 'inputEfectivo') {
                // CORREGIDO: Usar totalImpuestos en lugar de totalFactura
                const totalPagos = round(valorNumerico + montoPagado);
                if (valorNumerico > 0 && totalPagos > totalImpuestos) {
                    setMensaje({
                        mostrar: true,
                        titulo: 'Notificación',
                        texto: 'El Monto Efectivo más los Otros Pagos es Mayor al Monto Total a Pagar.',
                        icono: 'informacion'
                    });
                    event.target.value = '0,00';
                    txtEfectivo.current?.focus();
                } else {
                    //const totalPagado = round(totalPagos);

                    const { total, restante, sobrante } = recalcularTotales(records, valorNumerico);
                    setTotales(total);
                    setRestabs(restante);
                    setSobrabs(sobrante);
                }
                if (event.which === 13) {
                    btnAcepta.current?.focus();
                }
            }
        }
    }, [montoPagado, totalImpuestos]);

    const imprimirRecibo = (idfactura) => {
        if (!printer || printer.length === 0 || !printer[0]) {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: 'No se ha configurado la impresora',
                icono: 'error'
            });
            return;
        }

        const configImpresora = printer[0];
        const descripcion = configImpresora.impresora || 'default';
        const socket = configImpresora.socket || false;
        const username = configImpresora.server || 'default';
        const papel = configImpresora.papel || 'thermal';

        if (socket) {
            if (isConnected) {
                let data = {
                    message: configImpresora.message || 'imprimir',
                    server: username.toLowerCase(),
                    impresora: descripcion,
                    idfactura: idfactura,
                    fecha: fechaSistema,
                    tipo: 'reciboopensiap',
                    copias: 1,
                    papel: papel,
                    tipopago: tipoinput
                };

             

                sendPrint(data);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: 'Error de conexión',
                    texto: 'No hay conexión con el servidor de impresión',
                    icono: 'error'
                });
            }
        } else {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: 'No se ha configurado la impresora',
                icono: 'error'
            });
        }
    };

    // =========================================================================
    // FUNCIONES DE API
    // =========================================================================
    const seleccionartipoIngreso = useCallback((id) => {
        const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi`;

        axios.get(endpoint, {
            params: {
                campos: 'tabla',
                nomtab: 'tipoimpuesto',
                condi: `idtipoingreso = ${id}`,
                orden: 'idtipoimpuesto'
            },
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response.status === 200 && response.data && response.data[0]) {
                const tieneDeuda = props.deuda?.length > 0;
                const descripcion = response.data[0].tabla == '' || response.data[0].tabla === 'vehiculo' ;
                let valtipo;
                if (tieneDeuda) {
                    valtipo = descripcion ? 0 : 1;
                } else {
                    valtipo = 2;
                }

                setTipoinput(valtipo);
            } else {
                console.warn('Respuesta inesperada:', response);
                setTipoinput(2);
            }
        }).catch((error) => {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: error.response?.data?.message || 'Error al cargar tipos de ingreso',
                icono: 'error'
            });
        });
    }, [token, op.conexion, props.deuda]);

    const procesarPago = useCallback((body) => {
        const endpoint = `${op.conexion}/api/Caja_Ingreso/pagarfactura`;
        setActivate(true);

        // Validar que el body no sea null
        if (!body) {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: 'Error al preparar los datos del pago',
                icono: 'error'
            });
            setActivate(false);
            return;
        }

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response.status === 200) {
                setMensaje({
                    mostrar: true,
                    titulo: 'Éxito.',
                    texto: `La Transacción N°: ${response.data.numtransa} fue Procesada`,
                    icono: 'exito'
                });
                imprimirRecibo(response.data.numfactu);
                //imprimirTicket(response.data.nfact);
            }
        }).catch((error) => {
            console.error('Error en pago:', error.response?.data || error.message);
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: error.response?.data?.message || 'Error al procesar el pago',
                icono: 'error'
            });
        }).finally(() => {
            setActivate(false);
        });
    }, [token, op.conexion, imprimirRecibo]);

    // =========================================================================
    // HANDLERS DE ACCIONES - CORREGIDOS
    // =========================================================================
    const onChangeValidar = useCallback((e) => {
        e.preventDefault();

        const montoEfectivo = parseFloat(txtEfectivo.current?.value.replace(/\./g, '').replace(',', '.') || 0);
        const totalPagado = round(montoEfectivo + montoPagado);

        const totalAPagar = round(totalImpuestos);
        const { total, restante, sobrante } = recalcularTotales(records, montoEfectivo);
        setTotales(total);
        setRestabs(restante);
        setSobrabs(sobrante);
        // Validaciones
        if (total < totalAPagar) {
            setMensaje({
                mostrar: true,
                titulo: 'Notificación',
                texto: `El Monto Pagado (${formatMoneda(totalPagado.toString().replace(",", "").replace(".", ","), ",", ".", 2)}) es Diferente al Monto Total a Pagar (${formatMoneda(totalAPagar.toString().replace(",", "").replace(".", ","), ",", ".", 2)}).`,
                icono: 'informacion'
            });
            if (txtEfectivo.current) {
                txtEfectivo.current.value = '0,00';
                txtEfectivo.current.focus();
            }
            return;
        }

        if (!txtNombreContri.current?.value.trim()) {
            setMensaje({
                mostrar: true,
                titulo: 'Notificación',
                texto: 'El Nombre del Representante Legal no debe ir Vacio',
                icono: 'informacion'
            });
            txtNombreContri.current?.focus();
            return;
        }

        if (!txtFecha.current?.value.trim()) {
            setMensaje({
                mostrar: true,
                titulo: 'Notificación',
                texto: 'La Fecha es Invalida',
                icono: 'informacion'
            });
            txtFecha.current?.focus();
            return;
        }

        // Validar que la fecha no sea nula
        const fechaPago = txtFecha.current.value;
        if (!fechaPago) {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: 'La fecha de pago es requerida',
                icono: 'error'
            });
            return;
        }

        // Preparar datos para el pago - CORREGIDO
        const detallePago = [
            ...records.map(pago => ({
                fechadoc: pago.fechadoc || null,
                numdocumento: pago.numdocumento || '',
                monto: pago.monto || 0,
                tipopago: pago.idtipopago || 0,
                destipopago: pago.destipopago || '',
                idbanco: pago.idbanco || 0,
                nombanco: pago.nombanco || '',
                idcuentabancaria: pago.idcuentabancaria || 0,
                cuentabanco: pago.cuentabanco || null
            })),
            {
                fechadoc: null,
                numdocumento: '',
                monto: montoEfectivo,
                tipopago: 0,
                destipopago: 'EFECTIVO',
                idbanco: 0,
                nombanco: '',
                idcuentabancaria: 0,
                cuentabanco: null
            }
        ];

        // Validar que los datos requeridos no sean nulos
        if (!props.factura?.idfactura) {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: 'ID de factura no válido',
                icono: 'error'
            });
            return;
        }

        const body = {
            fechapag: fechaPago, // Ya es string YYYY-MM-DD
            ncaja: numCaja === null ? "" : String(numCaja), // Asegurar que sea string
            porcedes: 0.00,
            fechasis: fechaSistema, // Asegurar que sea string ISO
            idfact: String(props.factura.idfactura), // Asegurar que sea string
            espiritu: espiritu || 0,
            cajadet: JSON.stringify(detallePago),
            tdeuda: JSON.stringify(props.deuda || []),
            verifi: JSON.stringify(props.verificacion || [])
        };

        // Verificar que todos los campos tengan valores válidos

        // Validar que no haya null en campos críticos
        if (!body.fechapag || !body.idfact) {
            setMensaje({
                mostrar: true,
                titulo: 'Error',
                texto: 'Datos incompletos para procesar el pago',
                icono: 'error'
            });
            return;
        }

        // ELIMINAR ESTE RETURN - estaba causando que no se ejecute la petición
        // return;

        procesarPago(body);
    }, [montoPagado, totalImpuestos, formaPago, numCaja, fechaSistema, espiritu, props.factura, props.deuda, props.verificacion, procesarPago]);

    const gestionarPago = useCallback((op) => (e) => {
        const montoEfectivo = parseFloat(txtEfectivo.current?.value.replace(/\./g, '').replace(',', '.') || 0);
        const totalPagado = round(montoEfectivo + montoPagado);
        // CORREGIDO: Usar totalImpuestos
        const diferencia = round(totalImpuestos - totalPagado);

        setMontoPorPagar(diferencia);

        if (diferencia > 0) {
            if (op === 1) {
                setOperacion(1);
                setMostrar2(true);
            }
        } else {
            setMensaje({
                mostrar: true,
                titulo: 'Notificación',
                texto: 'El monto pagado es igual al monto total a pagar',
                icono: 'informacion'
            });
        }
    }, [montoPagado, totalImpuestos]);

    const handleAceptaPago = useCallback((datos) => {
        setMostrar2(false);

        const nuevoPago = {
            fechadoc: datos[0].fechadoc,
            numdocumento: datos[0].numdocumento,
            monto: parseFloat(datos[0].monto.replace(/\./g, '').replace(',', '.')),
            idtipopago: datos[0].idtipopago,
            destipopago: datos[0].destipopago,
            idbanco: datos[0].idbanco,
            nombanco: datos[0].nombanco,
            idcuentabancaria: datos[0].idcuentabancaria,
            cuentabanco: datos[0].cuentabanco
        };

        setFormaPago(prev => [...prev, nuevoPago]);
        setMontoPagado(prev => round(prev + nuevoPago.monto));
    }, []);

    const handleAceptaDatos = useCallback((values) => {
        setMostrar1(false);

        var pago = [];
        let monpag = 0.00;
        for (let i = 0; i < records.length; i++) {
            pago.push({
                fechadoc: records[i].fecha,
                numdocumento: records[i].referencia,
                monto: records[i].monto,
                idtipopago: records[i].formapago,
                destipopago: TIPOS_PAGO[records[i].formapago],
                idbanco: records[i].idbancocliente,
                nombanco: records[i].nombanco,
                idcuentabancaria: records[i].idcuentabancaria,
                cuentabanco: records[i].cuentabanco

            });
            monpag = monpag + parseFloat(records[i].monto);
        }

        pago.push({
            fechadoc: values[0].fecha,
            numdocumento: values[0].referencia,
            monto: values[0].monto,
            idtipopago: values[0].formapago,
            destipopago: TIPOS_PAGO[values[0].formapago],
            idbanco: values[0].idbancocliente,
            nombanco: values[0].nombanco,
            idcuentabancaria: values[0].idcuentabancaria,
            cuentabanco: values[0].cuentabanco
        });

        //monpag = monpag + parseFloat(values[0].monto.replace(/\./g, '').replace(',', '.'));


        monpag = monpag + parseFloat(values[0].monto);
        monpag = Math.round(monpag * Math.pow(10, 2)) / Math.pow(10, 2);
        setMontoPagado(monpag);
        setRecords(pago);
        /* const montoEfectivo = parseFloat(txtEfectivo.current.value.replace(/\./g, '').replace(',', '.') || 0);
        const { total, restante, sobrante } = recalcularTotales(records, montoEfectivo);
        setTotales(total);
        setRestabs(restante);
        setSobrabs(sobrante); */
        //setFormaPago(pago);

    }, [records.length, tasa, obtenerDescripcionPago]);

    const eliminarFila = useCallback((index) => (e) => {
        e.preventDefault();
        setRecords(prev => prev.filter(item => item.index !== index));

        // Actualizar montoPagado cuando se elimina un registro
        const recordEliminado = records.find(item => item.index === index);
        if (recordEliminado) {
            setMontoPagado(prev => round(prev - recordEliminado.monto));
            setFormaPago(prev => prev.filter(p => p.numdocumento !== recordEliminado.numdocumento));
        }
    }, [records]);

    const cancelar = useCallback((e) => {
        e.preventDefault();
        setFormaPago([]);
        setRecords([]);
        setMontoPagado(0.00);
        setTotales(0.00);
        setRestabs(totalImpuestos);
        setSobrabs(0.00);
        setTipoinput(null);
        props.onHideCancelar();
    }, [props, totalImpuestos]);

    const cerrarModal = useCallback(() => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        setFormaPago([]);
        setRecords([]);
        setMontoPagado(0.00);
        setTotales(0.00);
        setTipoinput(null);
        props.onHideRenderizar?.();
        props.onHideCancelar?.();
    }, [props]);

    const onGestionar = useCallback((op) => (e) => {
        if (op < 10) {
            setOperacion(op);
            setMostrar1(true);
        } else if (op === 10) {
            setOperacion(op);
            setMostrar3(true);
        }
    }, []);

    // =========================================================================
    // COMPONENTE DE TABLA PERSONALIZADO
    // =========================================================================
    const TablaPagos = useCallback(() => (
        <TableContainer className='border-table' style={{ height: 250, maxHeight: 250, width: '100%', overflow: 'auto' }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        {HEAD_CELLS.map((cell) => (
                            <TableCell
                                className='azulGradiant text-white'
                                key={cell.id}
                                align={cell.align}
                                style={{
                                    fontWeight: 'bold',
                                    padding: '8px'
                                }}
                            >
                                {cell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {records.length > 0 ? (
                        records.map((fpago) => (
                            <TableRow key={fpago.index} hover>
                                <TableCell align="center" style={{ padding: '4px' }}>
                                    {fpago?.destipopago || ''}
                                </TableCell>
                                <TableCell align="center" style={{ padding: '4px' }}>
                                    {fpago?.numdocumento || ''}
                                </TableCell>
                                <TableCell align="right" style={{ padding: '4px' }}>
                                    {fpago?.nombanco || ''}
                                </TableCell>
                                <TableCell align="right" style={{ padding: '4px' }}>
                                    {formatMoneda(fpago?.monto.toString()
                                        .replace(",", "")
                                        .replace(".", ","),
                                        ",",
                                        ".",
                                        2)}
                                </TableCell>
                                <TableCell align="center" style={{ padding: '4px' }}>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        style={{ padding: '2px 6px', fontSize: '12px' }}
                                        disabled={deshabilitado}
                                        onClick={eliminarFila(fpago.index)}
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5} align="center" style={{ padding: '16px' }}>
                                No hay pagos registrados
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    ), [records, deshabilitado, eliminarFila]);

    // =========================================================================
    // RENDERIZADO
    // =========================================================================
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionartipoIngreso(props.factura.idtipoingreso);
                btnAcepta.current.focus();
                txtCodigo.current.value = props.factura.idcontribuyente !== "0" ? props.factura.idcontribuyente : "";
                txtCedRif.current.value = props.factura.cedrif;
                txtNombreContri.current.value = props.factura.nombrecontri;
                txtConcepto.current.value = props.factura.descripcion;
                setOperacion(props.operacion);
                if (txtCodigo.current.value !== "") {
                    let impu = 0.00;
                    let inte = 0.00;
                    let reca = 0.00;
                    let mult = 0.00;
                    let totdeu = 0.00;
                    let totfac = 0.00;
                    let tasa = props.factura.tabladeuda !== null && (props.factura.tabladeuda.trim() === 'deudacomercio' || props.factura.tabladeuda.trim() === 'deudavehiculo' || props.factura.tabladeuda.trim() === 'deudarentas') ? 1 : parseFloat(props.tasa);
                    if (props.factura.tabladeuda === null || props.factura.tabladeuda.trim() === 'publicidad' || props.factura.tabladeuda.trim() === 'licores' || props.factura.tabladeuda.trim() === 'multa') {
                        totfac = parseFloat(props.factura.totalfactura);
                        totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
                    } else {
                        for (let i = 0; i < props.deuda.length; i++) {
                            impu = parseFloat(impu) + parseFloat(props.deuda[i].monto);
                            inte = parseFloat(inte) + parseFloat(props.deuda[i].intereses);
                            reca = parseFloat(reca) + parseFloat(props.deuda[i].recargo);
                            mult = parseFloat(mult) + parseFloat(props.deuda[i].multa);
                        }
                        totdeu = parseFloat(impu + inte + reca + mult) - parseFloat(props.factura.deducible);
                        //totdeu = Math.round((totdeu * parseFloat(props.tasa)) * Math.pow(10, 2)) / Math.pow(10, 2);

                        // totdeu = Math.round((totdeu * tasa) * Math.pow(10, 2)) / Math.pow(10, 2);
                        totfac = parseFloat(props.factura.totalfactura);
                        totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
                        if (totdeu !== totfac) {
                            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se puede procesar la transacción Hay diferencia entre el monto facturado y la deuda actual', icono: 'informacion' });
                            setDeshabilitado(true);
                            setHabilitado(true);
                            //props.onHideCancelar();
                        } else {
                            setDeshabilitado(false);
                            setHabilitado(false);
                        }
                    }
                } else {
                    setDeshabilitado(false);
                    setHabilitado(false);
                }
                if (props.verificacion.length > 0) {
                    var pago = [];
                    let monpag = 0.00;
                    for (let i = 0; i < props.verificacion.length; i++) {
                        pago.push({
                            fechadoc: props.verificacion[i].fecha,
                            numdocumento: props.verificacion[i].nrodocumento,
                            monto: props.verificacion[i].monto,
                            idtipopago: props.verificacion[i].tipo === 1 ? 3 : 2,
                            destipopago: props.verificacion[i].tipo === 1 ? 'DEPOSITO' : 'TRANSFERENCIA',
                            idbanco: props.verificacion[i].idbanco,
                            nombanco: props.verificacion[i].nombre,
                            idcuentabancaria: props.verificacion[i].idcuentabancaria,
                            cuentabanco: props.verificacion[i].cuentabancaria
                        });
                        monpag = monpag + parseFloat(props.verificacion[i].monto);
                    }

                    //monpag = monpag + parseFloat(datos[0].monto.replace(/\./g, '').replace(',', '.'));
                    monpag = Math.round(monpag * Math.pow(10, 2)) / Math.pow(10, 2);
                    setMontoPagado(monpag);
                    setFormaPago(pago);
                    setRecords(pago);
                    setDeshabilitado(true);
                    setHabilitado(false);
                }

            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light">
                    <h3>Caja</h3>
                </div>
                <button
                    ref={btnCancela}
                    className="btn bg-transparent"
                    style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
                    onClick={cancelar}
                >
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>

            <Modal.Body style={{ backgroundColor: "#FFF" }}>
                {/* Modales hijos */}
                <AgregarPago
                    show={mostrar2}
                    operacion={operacion}
                    fecha={props.fecha}
                    totalfactura={totalImpuestos} // CORREGIDO: Pasar totalImpuestos
                    porpagar={montoPorPagar}
                    onHideCancela={() => setMostrar2(false)}
                    onHideAcepta={handleAceptaPago}
                />

                <Mensaje
                    mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Éxito.'
                            ? cerrarModal()
                            : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
                    }}
                />

                <MensajeSiNo
                    mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })}
                    onHideSi={handleCloseSi}
                />

                <Dimmer active={activate} inverted />

                <div className='titulos' style={{ height: "auto", minHeight: "auto", maxHeight: "90vh" }}>
                    <div className="container">
                        {/* Datos de la Factura */}
                        <fieldset className="row border-table rounded mx-auto">
                            <legend className="float-none m-0 w-auto">Datos de la Factura</legend>
                            <div className='col-md-12 row mx-auto px-0'>
                                <div className="input-group input-group-sm mb-1 col-md-2">
                                    <label className="input-group-text">Código:</label>
                                    <input
                                        type="text"
                                        disabled
                                        ref={txtCodigo}
                                        className="form-control bg-light"
                                    />
                                </div>

                                <div className="col-md-4 oculto"></div>

                                <div className="input-group input-group-sm mb-1 col-md-3">
                                    <label className="input-group-text">Cédula o RIF:</label>
                                    <input
                                        type="text"
                                        disabled
                                        ref={txtCedRif}
                                        className="form-control bg-light"
                                    />
                                </div>

                                <div className="input-group input-group-sm mb-1 col-md-3">
                                    <label className="input-group-text">Fecha:</label>
                                    <input
                                        type="date"
                                        ref={txtFecha}
                                        defaultValue={moment(fechaSistema).format('YYYY-MM-DD')}
                                        className="form-control text-uppercase"
                                    />
                                </div>

                                <div className="input-group input-group-sm mb-1 col-md-12">
                                    <label className="input-group-text">Nombre del Contribuyente:</label>
                                    <textarea
                                        disabled
                                        ref={txtNombreContri}
                                        className="form-control bg-light"
                                        rows="2"
                                    />
                                </div>

                                <div className="input-group input-group-sm mb-1 col-md-12">
                                    <label className="input-group-text">Concepto:</label>
                                    <textarea
                                        disabled
                                        ref={txtConcepto}
                                        className="form-control bg-light"
                                        rows="2"
                                    />
                                </div>
                            </div>
                        </fieldset>

                        <div className='col-md-12 py-1'></div>

                        {/* Tabla de Deuda */}
                        <fieldset className='border-table rounded'>
                            <legend className="float-none m-0 w-auto">Deuda del Contribuyente</legend>
                            <div className='p-0'>
                                <TablaDeudaContribuyentes
                                    factura={props.factura}
                                    deuda={props.deuda}
                                />
                            </div>
                        </fieldset>

                        <div className='col-md-12 py-1'></div>

                        {/* Tipos de Pagos */}
                        <fieldset className='border-table rounded row m-0'>
                            <legend className="float-none m-0 w-auto">Tipos de Pagos</legend>

                            <div className='col-md-12 row justify-content-start px-0'>
                                <div className="input-group input-group-sm col-md-3 mb-1">
                                    <label className="input-group-text">Monto en Efectivo:</label>
                                    <input
                                        type="text"
                                        disabled={deshabilitado}
                                        ref={txtEfectivo}
                                        className="form-control text-right"
                                        placeholder='0,00'
                                        defaultValue='0,00'
                                        onFocus={seleccionarCampo}
                                        onKeyUp={handleInputMontoChange}
                                        onBlur={handleInputMontoChange}
                                        style={styleInput}
                                        id="inputEfectivo"
                                    />
                                </div>
                                <div className='col-md-9'></div>
                            </div>

                            {/* Botones de métodos de pago */}
                            <div className="col-4 row m-0 px-0 d-flex justify-content-center border-table py-2"
                                style={{ background: "#cfe2ff", borderRadius: "3px" }}>

                                {METODOS_PAGO.map((btn) => (
                                    <div key={btn.op} className="col-6 mb-2 d-flex justify-content-center">
                                        <button
                                            style={{ height: "80px", fontSize: "14px" }}
                                            onClick={onGestionar(btn.op)}
                                            disabled={
                                                deshabilitado ||
                                                (btn.op === 8 && props.siescredit !== 1) ||
                                                (btn.op === 9 && props.siesanticipo !== 1)
                                            }
                                            className="btn btn-sm btn-light col-md-12 p-1 border-3 border-light text-capitalize fw-bold"
                                        >
                                            <i className={`fas ${btn.icon} mr-2`}></i>
                                            {btn.text}
                                            {btn.op === 8 && ` ${formatMoneda(totalcredito.toString()
                                                .replace(",", "")
                                                .replace(".", ","),
                                                ",",
                                                ".",
                                                2)}`}
                                            {btn.op === 9 && ` ${formatMoneda(anticipos.toString()
                                                .replace(",", "")
                                                .replace(".", ","),
                                                ",",
                                                ".",
                                                2)}`}
                                        </button>
                                    </div>
                                ))}
                            </div>

                            {/* Tabla de pagos registrados */}
                            <div className='col-md-8 px-0'>
                                <TablaPagos />

                                {/* Totales */}
                                <div className="col-12 row m-0 px-0">
                                    <div className="col-6 ml-auto px-0 row m-0 d-flex align-items-center border-table py-2"
                                        style={{ background: "#cfe2ff", borderRadius: "3px" }}>

                                        <div className="col-12 px-1 row m-0 py-0">
                                            <label className="col-5 px-1 text-left">Total a Pagar Bs:</label>
                                            <span className="col px-0 fw-bold text-right">
                                                {formatMoneda(totalImpuestos.toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                    ",",
                                                    ".",
                                                    2)}
                                            </span>
                                        </div>

                                        <div className="col-12 px-1 row m-0 py-0">
                                            <label className="col-5 px-1 text-left">Total Cargado Bs:</label>
                                            <span className="col px-0 fw-bold text-right">
                                                {formatMoneda(totales.toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                    ",",
                                                    ".",
                                                    2)}
                                            </span>
                                        </div>

                                        <div className="col-12 px-1 row m-0 py-0">
                                            <label className="col-5 px-1 text-left">Restante a Pagar Bs:</label>
                                            <span className="col px-1 fw-bold text-right">
                                                {formatMoneda(restabs.toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                    ",",
                                                    ".",
                                                    2)}
                                            </span>
                                        </div>

                                        <div className="col-12 px-1 row m-0 py-0">
                                            <label className="col-5 px-1 text-left">Sobrante en Bs:</label>
                                            <span className="col px-1 fw-bold text-right">
                                                {formatMoneda(sobrabs.toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                    ",",
                                                    ".",
                                                    2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        {/* Botones de acción */}
                        <div className='col-md-12 py-1 d-flex justify-content-end align-items-center'>
                            <button
                                ref={btnAcepta}
                                disabled={habilitado}
                                onClick={onChangeValidar}
                                className="btn btn-sm rounded-pill btn-success col-md-2 me-2"
                            >
                                <i className="fas fa-check-circle"></i> Aceptar
                            </button>
                            <button
                                ref={btnCancela}
                                onClick={cancelar}
                                className="btn btn-danger btn-sm rounded-pill col-md-2"
                            >
                                <i className="fas fa-window-close"></i> Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <ProcesosMontos
                show={mostrar1}
                ope={operacion}
                data={records}
                restabs={restabs}
                idclients={props.idclient}
                onHideCancelar={() => setMostrar1(false)}
                onHideAceptaData={handleAceptaDatos}
            />
        </Modal>
    );
};